<div class="avatars-and-create-date">
  <ui-skeleton [uiActive]="true" [uiCustom]="true" [uiCustomMeasurements]="{ width: '100px', height: '16px', margin: '0 0 8px 0' }"></ui-skeleton>
  <ui-skeleton [uiActive]="true" [uiCustom]="true" [uiCustomMeasurements]="{ width: '200px', height: '16px', margin: '0 0 8px 0' }"></ui-skeleton>
</div>

<ui-skeleton [uiActive]="true" [uiCustom]="true" [uiCustomMeasurements]="{ width: '100%', height: '76px', margin: '32px 0 8px 0' }"></ui-skeleton>
